import { AuthConfiguration } from "./AuthConfigurationInterface";

const authConfiguration: AuthConfiguration = {
    enabled: false,
    debug: false,
    baseUrl: "http://localhost/",
    restServicesPath: "api/",
    appClientId: "e14d68df-f824-4709-9acb-4cd9a3c81c7e",
    appAuthority: "https://login.microsoftonline.com/c7d1a8f7-0546-4a0c-8cf5-3ddaebf97d51",
    redirectUri: "http://localhost/",
    cacheLocation: "localStorage",
    loginRequestScopes: [
        "api://3c56a349-9ecd-4bbe-a149-092028f4cc5a/Access",
    ],
    tokenRequestScopes: ["User.Read"],
    graphUsersEndpoint: "https://graph.microsoft.com/v1.0/users",
};

export { authConfiguration };
